import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
import _imports_0 from '../../assets/activitys/logo.png';
import _imports_1 from '../../assets/activitys/title.png';
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = {
  class: "detail"
};
const _hoisted_3 = {
  class: "activitys"
};
const _hoisted_4 = {
  class: "list"
};
const _hoisted_5 = {
  class: "swiper-container",
  ref: "swiperList"
};
const _hoisted_6 = {
  class: "swiper-wrapper"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "name"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`activitysIndex ${this.isMobile ? 'h5' : ''}`)
  }, [_createElementVNode("div", _hoisted_1, [_cache[4] || (_cache[4] = _createElementVNode("img", {
    class: "logo",
    src: _imports_0
  }, null, -1)), _cache[5] || (_cache[5] = _createElementVNode("div", null, [_createElementVNode("img", {
    class: "title",
    src: _imports_1
  })], -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: "pintu",
    onClick: _cache[0] || (_cache[0] = $event => $options.toDetail(0))
  }), _createElementVNode("div", {
    class: "dati",
    onClick: _cache[1] || (_cache[1] = $event => $options.toDetail(1))
  })]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
    class: "icon",
    onClick: _cache[2] || (_cache[2] = $event => $options.toDetail(2, _ctx.item))
  }), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.activityList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-slide navItem",
      onClick: $event => $options.openDetail(item.url)
    }, [_createElementVNode("img", {
      src: item.img
    }, null, 8, _hoisted_8), _createElementVNode("div", _hoisted_9, _toDisplayString(item.name), 1)], 8, _hoisted_7);
  }), 256))])], 512), _cache[3] || (_cache[3] = _createElementVNode("div", {
    class: "pagination"
  }, null, -1))])])])], 2);
}